import React, { lazy } from 'react';
import { ArrowRight, Star, ShieldCheck, Flame } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function PricingSection() {
  return <section id="offre" className="bg-gradient-to-b from-pilates-sage-dark to-pilates-dark py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-141">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-pilates-lavender/15 rounded-full blur-3xl pointer-events-none" data-id="element-142"></div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-143">
        <div className="bg-white/10 backdrop-blur-sm border border-white/20 text-white font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-144">
          Offre Spéciale — Pack Complet 6 en 1
        </div>
        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-white leading-tight mb-4 tracking-tight" data-id="element-145">
          Accédez au système maintenant et transformez vos cours{' '}
          <span className="italic text-pilates-cream" data-id="element-146">dès aujourd'hui</span>
        </h2>

        <div className="mb-8 max-w-md mx-auto mt-10" data-id="element-147">
          <img src="https://cdn.magicpatterns.com/uploads/988bYnGKoQkwizPHuxZ3Jx/heylloyd-image-1779985889202.webp" alt="Pack Pilates Prêt 6 en 1" className="w-full rounded-2xl shadow-2xl" loading="lazy" decoding="async" width="800" height="800" data-id="element-148" />
        </div>

        <div id="pricing-card" className="bg-white rounded-3xl p-6 sm:p-8 shadow-2xl max-w-md mx-auto scroll-mt-8" data-id="element-149">
          <p className="text-pilates-slate text-sm mb-1" data-id="element-150">
            Prix Normal : <span className="line-through" data-id="element-151">97€</span>
          </p>

          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-pilates-rose to-pilates-rose-dark text-white text-xs font-bold px-3 py-1.5 rounded-full my-3 uppercase tracking-wide" data-id="element-152">
            <Flame className="w-4 h-4" data-id="element-153" /> 70% OFF — Offre de Lancement
          </div>

          <p className="text-pilates-slate text-sm mb-1" data-id="element-154">
            Prix avec réduction :
          </p>
          <p className="font-display text-6xl sm:text-7xl font-semibold text-pilates-rose mb-3 leading-none" data-id="element-155">
            27€
          </p>

          <p className="text-pilates-rose font-semibold text-sm mb-5 flex items-center justify-center gap-1" data-id="element-156">
            🔥 Il ne reste que 23 copies avec cette réduction
          </p>

          <div className="mb-6" data-id="element-157">
            <CountdownTimer data-id="element-158" />
          </div>

          <a href="https://pilates-pret.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="group w-full bg-gradient-to-r from-pilates-rose to-pilates-rose-dark text-white font-semibold text-base sm:text-lg py-4 px-6 rounded-full shadow-[0_10px_30px_rgba(201,123,99,0.4)] hover:shadow-[0_15px_40px_rgba(201,123,99,0.6)] hover:-translate-y-1 transition-all duration-300 flex items-center justify-center gap-3" data-id="element-159">
            <span data-id="element-160">🌿 Je veux mon Pack 6 en 1 (27€)</span>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-161" />
          </a>

          <div className="mt-5 flex flex-col items-center gap-2" data-id="element-162">
            <div className="flex items-center gap-2" data-id="element-163">
              <div className="flex text-pilates-rose" data-id="element-164">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4" fill="currentColor" data-id="element-165" />)}
              </div>
              <span className="text-pilates-slate text-sm font-medium" data-id="element-166">
                4.9/5 — avis vérifiés
              </span>
            </div>
            <div className="flex items-center gap-2 text-pilates-slate text-sm" data-id="element-167">
              <ShieldCheck className="w-4 h-4 text-pilates-sage-dark" data-id="element-168" />
              <span data-id="element-169">Garantie de 30 Jours — Risque Zéro</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}